var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4736 0.917969C14.6309 0.91799 16.3365 1.34525 17.4834 2.49219C18.63 3.63909 19.0576 5.34408 19.0576 7.50098V12.501C19.0576 14.6581 18.6303 16.3638 17.4834 17.5107C16.3365 18.6576 14.6308 19.0849 12.4736 19.085H7.47363C7.24184 19.085 7.01516 19.0786 6.79395 19.0684C6.74442 19.0787 6.69321 19.0849 6.64062 19.085C6.56054 19.085 6.48447 19.0682 6.41211 19.0449C4.75255 18.9172 3.41656 18.4622 2.46484 17.5107C1.31793 16.3638 0.890668 14.6581 0.890625 12.501V7.50098C0.890668 5.34388 1.31799 3.6391 2.46484 2.49219C3.41584 1.54119 4.75024 1.08516 6.4082 0.957031C6.48156 0.933069 6.55926 0.917969 6.64062 0.917969C6.69385 0.91798 6.74581 0.923041 6.7959 0.933594C7.01649 0.923422 7.24253 0.917973 7.47363 0.917969H12.4736ZM7.39062 2.41895V17.583C7.41809 17.5832 7.44586 17.585 7.47363 17.585H12.4736C14.4828 17.5849 15.6948 17.1782 16.4229 16.4502C17.1508 15.7222 17.5576 14.5101 17.5576 12.501V7.50098C17.5576 5.49218 17.1506 4.28077 16.4229 3.55273C15.6948 2.82472 14.4829 2.41799 12.4736 2.41797H7.47363C7.44586 2.41797 7.41809 2.41879 7.39062 2.41895ZM5.89062 2.52246C4.78953 2.68674 4.03785 3.04028 3.52539 3.55273C2.79745 4.28074 2.39067 5.49189 2.39062 7.50098V12.501C2.39067 14.5101 2.7974 15.7222 3.52539 16.4502C4.03782 16.9624 4.78986 17.3142 5.89062 17.4785V2.52246Z",
    fill: "url(#paint0_linear_22977_76939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4732 7.86719L10.3398 10.0005L12.4732 12.1339",
    stroke: "url(#paint1_linear_22977_76939)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22977_76939",
    x1: 9.97412,
    y1: -9.31569,
    x2: -10.4932,
    y2: 8.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22977_76939",
    x1: 11.4065,
    y1: 5.46373,
    x2: 7.81657,
    y2: 7.05696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideBar);
export default __webpack_public_path__ + "static/media/hide-bar.377c9188498fe24253c7bbe1162de571.svg";
export { ForwardRef as ReactComponent };